import React, { useEffect, useId, useState } from "react";
import { FaChevronDown } from "react-icons/fa";

export const SUMMARY_EXPANDED_STORAGE_KEY = "cocoPortal.summaryExpanded";

const readExpanded = (storageKey) => {
  try {
    return window.localStorage.getItem(storageKey) !== "false";
  } catch (error) {
    return true;
  }
};

const CollapsibleSummary = ({
  title,
  headingId,
  storageKey = SUMMARY_EXPANDED_STORAGE_KEY,
  children,
}) => {
  const panelId = useId();
  const [expanded, setExpanded] = useState(() => readExpanded(storageKey));

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, String(expanded));
    } catch (error) {
      // The toggle still works for this page when storage is unavailable.
    }
  }, [expanded, storageKey]);

  const toggle = (
    <button
      type="button"
      className="summary-toggle"
      aria-expanded={expanded}
      aria-controls={panelId}
      onClick={() => setExpanded((value) => !value)}
    >
      <span className="summary-toggle-label">{title}</span>
      <FaChevronDown className="summary-toggle-chevron" aria-hidden="true" />
    </button>
  );

  return (
    <div className={`summary-collapsible ${expanded ? "is-expanded" : "is-collapsed"}`}>
      {headingId ? (
        <h3 id={headingId} className="summary-toggle-heading">{toggle}</h3>
      ) : toggle}
      <div id={panelId} className="summary-collapsible-panel">
        <div className="summary-collapsible-inner">{children}</div>
      </div>
    </div>
  );
};

export default CollapsibleSummary;
